import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-five-one',
  templateUrl: './two-five-one.component.html',
  styleUrls: ['./two-five-one.component.scss']
})
export class TwoFiveOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
